import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IDisableWorkbookAccelerationParams {
  targetIds: string[];
}

export class DisableWorkbookAccelerationRequest extends Request<IDisableWorkbookAccelerationParams, IResult> {
  constructor(params: IDisableWorkbookAccelerationParams) {
    super('disableWorkbookAcceleration', params);
  }
}
